// New .ts date picker
// FIXME: Name is a bit ambiguous
angular.module("leanlaw").directive("dateSelect", ["$rootScope", function ($rootScope) {
  return {
    restrict: 'EA',
    scope: {
      date: '=?ngModel',
      dateopen: '=?',
      onChange: '=?ngChange',
      disabled: '=?ngDisabled',
      required: '=?ngRequired'
    },
    template: require('./views/dateSelect.html'),
    link($scope) {
      $scope.changeDate = function changeDate() {
        if (typeof $scope.onChange === "function") $scope.onChange($scope.date);
      };

      // Close or open the date picker
      $scope.toggle = function toggle() {
        if ($scope.dateopen) {
          // Closing
          $scope.changeDate();
        } else {
          // Opening
          $rootScope.$emit("ll-dateSelectOpenEvent", $scope.$id);
        }
        $scope.dateopen = !$scope.dateopen;
      };

      // Close the date picker when another one opens
      $rootScope.$on("ll-dateSelectOpenEvent", (event, elementid) => {
        // Don't ever listen to yourself
        if (elementid === $scope.$id) return;
        $scope.dateopen = false;
      });
    }
  };
}]);